import { render, staticRenderFns } from "./ShopReport.vue?vue&type=template&id=51fe7476&scoped=true"
import script from "./ShopReport.vue?vue&type=script&lang=ts"
export * from "./ShopReport.vue?vue&type=script&lang=ts"
import style0 from "./ShopReport.vue?vue&type=style&index=0&id=51fe7476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe7476",
  null
  
)

export default component.exports